import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import Button from './components/Button';

import { devLog } from '../../../utils/devLog';
const Login = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({ email: '', password: '' });

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        devLog('Login attempt:', formData.email);
        navigate('/template9');
    };

    return (
        <div className="w-full min-h-screen bg-[#F8FAFC] flex items-center justify-center px-4 py-12" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div className="flex items-center justify-center gap-2 mb-4 cursor-pointer" onClick={() => navigate('/template9')}>
                        <div className="w-2 h-6 bg-[#2563EB] rounded-none" />
                        <span className="text-2xl font-bold tracking-[3px] text-[#0F172A]">NAKSHA</span>
                    </div>
                    <p className="text-sm text-[#64748B] font-light">Welcome back to precision fashion</p>
                </div>

                {/* Login Form */}
                <div className="bg-white border border-[#E2E8F0] rounded-none p-6 sm:p-8 relative">
                    <div className="absolute top-0 left-0 w-1 h-full bg-[#2563EB]" />
                    <h2 className="text-xl font-semibold text-[#0F172A] mb-6">Sign In</h2>
                    <div className="w-8 h-0.5 bg-[#2563EB] mb-6" />

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-2">Email</label>
                            <div className="relative">
                                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]" />
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="your@email.com"
                                    required
                                    className="w-full pl-10 pr-4 py-3 text-sm border border-[#E2E8F0] rounded-none focus:outline-none focus:border-[#2563EB] bg-white text-[#0F172A] placeholder-[#94A3B8]"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-xs font-medium text-[#0F172A] uppercase tracking-wider mb-2">Password</label>
                            <div className="relative">
                                <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    placeholder="Enter password"
                                    required
                                    className="w-full pl-10 pr-10 py-3 text-sm border border-[#E2E8F0] rounded-none focus:outline-none focus:border-[#2563EB] bg-white text-[#0F172A] placeholder-[#94A3B8]"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 -translate-y-1/2 bg-transparent border-none cursor-pointer p-0"
                                >
                                    {showPassword ? <EyeOff size={16} className="text-[#64748B]" /> : <Eye size={16} className="text-[#64748B]" />}
                                </button>
                            </div>
                        </div>

                        <div className="flex items-center justify-between">
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input type="checkbox" className="accent-[#2563EB]" />
                                <span className="text-xs text-[#64748B]">Remember me</span>
                            </label>
                            <button type="button" className="text-xs text-[#2563EB] hover:text-[#1D4ED8] bg-transparent border-none cursor-pointer font-medium">
                                Forgot password?
                            </button>
                        </div>

                        <Button variant="primary" size="lg" fullWidth type="submit">
                            Sign In
                        </Button>
                    </form>

                    <div className="mt-6 text-center">
                        <p className="text-sm text-[#64748B] font-light">
                            Don't have an account?{' '}
                            <button
                                onClick={() => navigate('/template9/signup')}
                                className="text-[#2563EB] hover:text-[#1D4ED8] font-medium bg-transparent border-none cursor-pointer"
                            >
                                Create Account
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
